import React from "react"
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import { ErrorReset } from "store/errorscreen/actions";

//Import Images
import error from "../assets/images/svg/error/401-unauthorized.svg";

const UnAuthorized = () => {
  //meta title
  document.title = "401 - UnAuthorized | Glottis Logistics";
  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <div className="error-screen">
        <div className="account-pages m-0 pt-5">
          <Container>
            <Row>
              <Col lg="12">
                <div className="text-center">
                  <h1 className="display-2 fw-medium">
                    4<i className="bx bx-buoy bx-spin text-primary display-3" />
                    1
                  </h1>
                  <h4 className="text-uppercase">Unauthorized</h4>
                  <p className="font-size-16">You are not authorized to view the requested page.</p>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md="8" xl="6">
                <div className="error-img">
                  <img src={error} alt="401" className="img-fluid" />
                </div>
                <div className="d-flex justify-content-center action-btn">
                  <div className="text-center mx-2">
                    {/* <Link
                      className="btn btn-primary waves-effect waves-light "
                      to="/dashboard"
                      onClick={() => { dispatch(ErrorReset()); }}
                    >
                      Back to Dashboard
                    </Link> */}
                  </div>
                  <div className="text-center mx-2">
                    <Link
                      className="btn btn-primary waves-effect waves-light "
                      to="/logout"
                      onClick={()=>{ dispatch(ErrorReset());}}
                    >
                      Back to Login
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default UnAuthorized
